import { createSliceSteamup } from '../common';

interface ISteamXRState {
  loading: boolean;
}

const steamXRSlice = createSliceSteamup(
  'steamXR',
  {
    loading: true,
  } as ISteamXRState,
  {

  },
);

export default steamXRSlice;
